<template>
	<div class="d-flex flex-column justify-center align-center flex-grow-1">
		<div style="width: 500px; height: 150px">
			<v-img src="@/assets/fps.png" contain height="100%" />
		</div>
		<h1 class="text-h6 text-uppercase">{{ $T('beehive-system') }}</h1>
		<span class="text-body-1">v{{ version }}</span>
	</div>
</template>

<script>
import { VERSION } from '@/utils/constants';

export default {
	name: 'Home',

	data() {
		return {
			version: VERSION,
		};
	},
};
</script>
